import ReactGA from "react-ga";

/**
 * 头部导航点击跳转setting页面
 */
const GAHeaderClickToPersonCenter = label => {
    ReactGA.event({
        category: "navigation",
        action: "navigation_personcenter_click",
        label,
    });
};

/**
 * 头部导航点击退出登录
 */
const GAHeaderClickLogout = () => {
    ReactGA.event({
        category: "navigation",
        action: "navigation_logout_click",
    });
};

//头部导航点击跳转登录页面
const GAHeaderClickLogin = () => {
    ReactGA.event({
        category: "navigation",
        action: "navigation_login_click",
    });
};

//头部导航点击跳转注册页面
const GAHeaderClickSignUp = () => {
    ReactGA.event({
        category: "navigation",
        action: "navigation_signup_click",
    });
};

export {
    GAHeaderClickToPersonCenter,
    GAHeaderClickLogout,
    GAHeaderClickLogin,
    GAHeaderClickSignUp
};